import { useMediaQuery } from "react-responsive";

export const ResponsiveSizes = {
  mobileSize: "768px",
  // tabletSize: "900px",
};

const useResponsive = () => {
  return useMediaQuery({
    query: `(max-width: ${ResponsiveSizes.mobileSize})`,
  });
};

export default useResponsive;
